import { storageService } from 'framework/utils';
import { useCrudService } from 'framework/crud';
import { usePeopleManagementApi } from 'infrastructure/api';

export type BusinessFunction = {
  id: string;
  name: string;
};

const useBusinessFunctionService = () => {
  const { searchAll } = useCrudService({
    listResourceUrl: '/business-functions',
    singleResourceUrl: '/business-functions/:id',
    useService: usePeopleManagementApi,
  });

  const findAllFromApi = async (): Promise<BusinessFunction[]> => searchAll({});

  const { getDataFromStorage } = storageService('businessFunctions', findAllFromApi, '1.1');

  const findById = async (id: string): Promise<BusinessFunction | undefined> => {
    const businessFunctions = await getDataFromStorage();
    return businessFunctions.find((businessFunction: BusinessFunction) => businessFunction.id === id);
  };

  return {
    findAll: getDataFromStorage as () => Promise<BusinessFunction[]>,
    findById,
  };
};

export default useBusinessFunctionService;
